import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {ZahtevZaPogresnoUplacenaSredstvaDocument} from "./ZahtevZaPogresnoUplacenaSredstvaDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: broj računa, razlog, lista priloga
export const zahtevZaPogresnoUplacenaSredstvaDocumentFields: IntercateKeysMap<ZahtevZaPogresnoUplacenaSredstvaDocument, EntityField<ZahtevZaPogresnoUplacenaSredstvaDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	policyNumber: {
		name: "policyNumber", dataType: EntityFieldDataType._string, label: "Broj polise",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
	accountNumber: {
		name: "accountNumber", dataType: EntityFieldDataType._string, label: "Broj računa",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	explanation: {
		name: "explanation", dataType: EntityFieldDataType._string, label: "Razlog",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: (item: { clientId: any; }) => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<ZahtevZaPogresnoUplacenaSredstvaDocument>> = [
	zahtevZaPogresnoUplacenaSredstvaDocumentFields.indexingNumber,
	zahtevZaPogresnoUplacenaSredstvaDocumentFields.indexingDate,
	zahtevZaPogresnoUplacenaSredstvaDocumentFields.documentNumber,
	zahtevZaPogresnoUplacenaSredstvaDocumentFields.documentDate,
	zahtevZaPogresnoUplacenaSredstvaDocumentFields.policyNumber,
	zahtevZaPogresnoUplacenaSredstvaDocumentFields.assignedTo,
	zahtevZaPogresnoUplacenaSredstvaDocumentFields.clientId,
	zahtevZaPogresnoUplacenaSredstvaDocumentFields.sectorId,
	zahtevZaPogresnoUplacenaSredstvaDocumentFields.tags,
	zahtevZaPogresnoUplacenaSredstvaDocumentFields.parentId
]

export const zahtevZaPogresnoUplacenaSredstvaFieldsDescriptor: EntityFieldsDescriptor<ZahtevZaPogresnoUplacenaSredstvaDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
